import Http from './http'

class EstatisticasService {
  constructor() {
    this.baseUrl = '/estatisticas/biblioteca'
  }

  categorias(filter) {
    return this.generico('categorias',filter)
  }
  tags(filter) {
    return this.generico('tags',filter)
  }
  livros(filter) {
    return this.generico('livros',filter)
  }
  autores(filter) {
    return this.generico('autores',filter)
  }
  generico(endpoint, filter) {
    let url = `${this.baseUrl}/${endpoint}`

    if (filter) {
      url += `?${this.buildFilterUrl(filter)}`
    }
    return Http.get(url)
  }

  buildFilterUrl(filter) {
    return Object.keys(filter)
      .map((key) => {
        if (key === 'orderBy') {
          return filter.orderBy.map(
            (order) => `orderBy[]=${order.orderBy},${order.direction || 'asc'}`
          )
        }
        if(filter[key] === null || filter[key] === '') {
          return ''
        }
        return `${key}=${filter[key]}`
      })
      .join('&')
  }
}

export default new EstatisticasService()
